import { create } from "zustand";
import i18n from "@/i18n";

const LANGUAGE_KEY = "trata_web_language";
const SELECTED_KEY = "trata_web_language_selected";

function loadInitial() {
  try {
    const lang = localStorage.getItem(LANGUAGE_KEY) || "en";
    const selected = localStorage.getItem(SELECTED_KEY) === "true";
    return { language: lang, isLanguageSelected: selected };
  } catch (e) {
    return { language: "en", isLanguageSelected: false };
  }
}

const initial = loadInitial();

export const useLanguageStore = create((set) => ({
  language: initial.language,
  isLanguageSelected: initial.isLanguageSelected,

  setLanguage: (lang) => {
    try {
      localStorage.setItem(LANGUAGE_KEY, lang);
    } catch (e) {
      // ignore
    }
    i18n.changeLanguage(lang);
    set({ language: lang });
  },

  markLanguageSelected: () => {
    try {
      localStorage.setItem(SELECTED_KEY, "true");
    } catch (e) {
      // ignore
    }
    set({ isLanguageSelected: true });
  },
}));
